import { useRef, useEffect } from 'react';

function TodoCUserBox(props: any) {
  let myProps = {
    Style: {},
    has_start: false,
    student_info_arr: [],
    listOpt: {},
    search_room_list: [],
    ...props
  };
  let Style = myProps.Style;
  let student_info_arr = myProps.student_info_arr;
  let complete_cicle_ico_70 = process.env.REACT_APP_API_URL + "/img/comp/plan/check_ico_70.png";
  if (myProps.has_start) {
    complete_cicle_ico_70 = process.env.REACT_APP_API_URL + "/img/comp/plan/complete_cicle_ico_70.png";
  }
  let search_subject_name = "";
  if (myProps.listOpt && myProps.listOpt && myProps.listOpt.s_room_seq) {
    let search_room_list = myProps.search_room_list;
    for (let i = 0; i < search_room_list.length; i++) {
      let room_info = search_room_list[i];
      if (room_info.a_seq === myProps.listOpt.s_room_seq) {
        search_subject_name = room_info.a_subject;
        break;
      }
    }
  }

  const star_stu_wrap_ref = useRef<HTMLDivElement>(null);
  const star_stu_wrap_data_ref = useRef<any>({
    top: 0,
    is_ing: true,
  });
  useEffect(() => {
    let anim_loop = setInterval(() => {
      if (star_stu_wrap_data_ref.current.is_ing === false) {
        return false;
      }
      if (star_stu_wrap_ref.current) {
        let wrap_height = star_stu_wrap_ref.current.offsetHeight;
        if (wrap_height < 110) {
          return false;
        }
        star_stu_wrap_data_ref.current.top--;
        if (star_stu_wrap_data_ref.current.top < -wrap_height) {
          star_stu_wrap_data_ref.current.top = wrap_height - 20;
        }
        star_stu_wrap_ref.current.style.top = star_stu_wrap_data_ref.current.top + "px";
      }
    }, 50);
    return () => {
      clearInterval(anim_loop);
    };
  }, []);

  const get_able_stu_arr = () => {
    let able_stu_arr: any = [];
    if (student_info_arr && student_info_arr.length > 0) {
      for (let i = 0; i < student_info_arr.length; i++) {
        let stu_info = student_info_arr[i];
        let is_able_user = false;
        let stu_start_cnt = 0;
        if (stu_info.todo_dailyc_arr && stu_info.todo_dailyc_arr.length > 0) {
          for (let j = 0; j < stu_info.todo_dailyc_arr.length; j++) {
            let dailyc_info = stu_info.todo_dailyc_arr[j];
            if (dailyc_info.a_star_cnt) {
              stu_start_cnt += parseInt(dailyc_info.a_star_cnt);
            }
            if (dailyc_info.a_teacher_star) {
              stu_start_cnt += parseInt(dailyc_info.a_teacher_star);
            }
          }
          if (myProps.has_start) {
            if (stu_start_cnt > 0) {
              is_able_user = true;
            }
          } else {
            if (stu_start_cnt === 0) {
              is_able_user = true;
            }
          }
          if (search_subject_name&&is_able_user) {
            is_able_user=false;
             for (let j = 0; j < stu_info.todo_dailyc_arr.length; j++) {
              let dailyc_info = stu_info.todo_dailyc_arr[j];
              if(dailyc_info.a_subject==search_subject_name){
                is_able_user = true;
              }
            }
          }
        }
        if (is_able_user) {
          able_stu_arr.push({
            ...stu_info,
            star_cnt: stu_start_cnt,
          });
        }
      }
    }
    return able_stu_arr;
  };

  const get_start_img_tags=(star_cnt:number)=>{
    let start_img_src = process.env.REACT_APP_API_URL + "/img/comp/plan/star_yellow50.png";
    let star_img_tags = [];
    for (let i = 0; i < star_cnt; i++) {
      star_img_tags.push(
        <img key={i} src={start_img_src} style={{ height: "24px", marginLeft: "1px" }} />
      );
    }
    return star_img_tags;
  };

  const get_stu_name_tags = () => {
    let able_stu_arr = get_able_stu_arr();
    let start_img_src = process.env.REACT_APP_API_URL + "/img/comp/plan/star_yellow50.png";
    let stu_name_tags = able_stu_arr.map((stu_info: any, idx: number) => {
      return (
        <span key={idx} className={Style.star_stu_span}>
          {stu_info["a_user_name"]}
          {stu_info["star_cnt"] > 0 &&
            <span>
              {get_start_img_tags(stu_info["star_cnt"])}
            </span>
          }
        </span>
      );
    });
    return stu_name_tags;
  };
  return (
    <div className={Style.search_box_side}>
      <img src={complete_cicle_ico_70} className={Style.search_box_side_left_img} />
      <div className={Style.search_box_side_con}
        onMouseEnter={() => { star_stu_wrap_data_ref.current.is_ing = false; }}
        onMouseLeave={() => { star_stu_wrap_data_ref.current.is_ing = true; }}>
        <div className={Style.star_stu_wrap} ref={star_stu_wrap_ref}>
          {get_stu_name_tags()}
        </div>
      </div>
    </div>
  );
};
export default TodoCUserBox;